module.exports = __webpack_public_path__ + "static/media/1POLICY13.772c573b.jpg";